import type { useTranslations } from 'use-intl';

import {
  EXTENSION_SUPPORTED_BROWSERS,
  ExtensionSupportedBrowser,
} from '~marketing/constants/extension-supported-browsers';

export const getDownloadLinkProps = ({
  browser,
  placement,
  t,
}: {
  browser: ExtensionSupportedBrowser;
  placement: string;
  t: ReturnType<typeof useTranslations>;
}) => {
  const browserInfo = EXTENSION_SUPPORTED_BROWSERS[browser];
  const linkId = `atlas-download-${browser}-${placement}`;
  const linkText = t('addToBrowser', { browserName: browserInfo.shortName });

  return {
    anchorProps: {
      id: linkId,
      href: browserInfo.href,
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    linkText,
  };
};
